
import { defineComponent, inject, onMounted } from "vue";
  import { useRoute, useRouter } from 'vue-router';
  import { useStore } from 'vuex';
import {useI18n} from 'vue-i18n';
  import 'vue3-carousel/dist/carousel.css';
  import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';
  import News from '@/components/home/News.vue';
  import Events from '@/components/home/Events.vue';

  export default defineComponent({
    name: 'dashboard',
    components: {
      News,
      Events,
      Carousel,
      Slide,
      Pagination,
      Navigation,
    },
    methods:{
      scrollTo(){
       let video_portal:any =  document.getElementById("video_portal");
       if (video_portal) {
         window.scrollTo({
           top: video_portal.scrollHeight + 200,
           behavior: 'smooth'
         })
       }
      }
    },
    setup() {
      const router = useRouter();
      const store = useStore();
      const i18n = useI18n();
      const helpers: any = inject('helpers');
      // const handleChangeImage = (evt: Event | any)=>{
      //   let file = evt.target.files[0];
      //   helpers.OptimizeImage(file).then((R)=>{
      //     console.log(R,(R.originalFile.size/1024).toFixed(2) + " KB",(R.compressFile.size/1024).toFixed(2) + " KB")
      //   })
      // }

      return {
        store,
        i18n,
        // handleChangeImage
      };
    },
  });
